/**
 * 관리자 오더 핸들링 팝업 ($j.Pages.Admin.OrderHandle / body data-page-name="OrderHandle")
 *
 * 레거시 public/manage__pop__order_handle.php 의 렌더링/초기화 로직을 이관.
 * blade(adm/pages/order/handle.blade.php)는 #page-data(JSON) 주입과
 * #order-handle-root 컨테이너만 두고, DOM 생성·초기화는 이 모듈이 담당한다.
 *
 * 각 액션 버튼의 onclick 은 OrderHandle/orderEdit.js 의 전역 함수를 호출하며,
 * 그 함수들이 참조하는 전역 변수(ordernum, order_info, gps1 …)는 setGlobals() 에서 세팅한다.
 * 디자인은 match-list 페이지와 동일한 언어(resources/sass/admin/pages/_order-handle.scss).
 *
 * 데이터: OrderController@handle → OrderHandleService::getData() 가 반환한 JSON
 */
import './OrderHandle/orderEdit'; // 레거시 a-order-edit.js 액션함수들을 window.* 로 등록 (side-effect)
import Util from '../../Common/Util';

export default class OrderHandle {
    /** app.js loadPageModule 이 DOM ready 후 호출 */
    initialize() {
        this.D = JSON.parse(document.getElementById('page-data')?.textContent || '{}');
        this.oRaw = this.D.orderInfo || {};       // 원본 (order_info 전역으로 그대로 전달)
        this.o = OrderHandle.nullToEmpty(this.oRaw); // 렌더용 — null/undefined → '' 로 정규화
        if (!this.o.num) return;

        // 초기 탭 — 사진이 한 장이라도 있으면 사진, 없으면 지도 (render 전에 정해야 한다)
        this.fieldTab = this.hasPhoto() ? 'photo' : 'map';

        // 미리보기는 언제나 발주자의 발주화면에서 시작한다 (기억하지 않는다 — 창마다 같은 자리)
        this.who = 'bal';          // 미리보기 계정 : 'bal' 발주자 / 'work' 수주자
        this.previewView = 'bal';  // 미리보기 화면 : 'bal' 발주(오더수정) / 'diary' 일지

        this.setGlobals();
        this.definePageFns();

        const root = document.getElementById('order-handle-root');
        if (root) root.innerHTML = this.renderHtml();

        this.initView();
    }

    /** 객체의 null/undefined 값을 ''(빈 문자열)로 치환한 얕은 복사본 반환 (화면에 'null' 출력 방지) */
    static nullToEmpty(obj) {
        const out = {};
        for (const k in obj) {
            const v = obj[k];
            out[k] = (v === null || v === undefined) ? '' : v;
        }
        return out;
    }

    /** orderEdit.js 전역 함수들이 참조하는 페이지 전역 변수 세팅 */
    setGlobals() {
        const { D, o } = this;
        const g1 = D.gps1 === '' ? 0 : Number(D.gps1);
        const g2 = D.gps2 === '' ? 0 : Number(D.gps2);

        Object.assign(window, {
            order_info: this.oRaw,
            wwod: 0,
            gps1: g1,
            gps2: g2,
            gps: `${g1},${g2}`,
            ordernum: D.ordernum,
            crrent_price: parseInt(o.car_price, 10) || 0,
            crrent_priceshow: Util.formatNumber(o.car_price),
            car_type: o.car_type,
            order_member_num_val: String(parseInt(o.order_member_num, 10) || 0),
            needToRollBack: D.cancelRollback,
            eaoinfo_order_address: o.site_address,
            oderoption: D.carOptionArr || [],
            order_status: D.orderStatus,
            worker_num: parseInt(o.worker_num, 10) || 0,
            worker_owner_num: parseInt(o.worker_owner_num, 10) || 0,
            This_order_OwnerNum: parseInt(o.order_owner_num, 10) || 0,
            IsEmergency: D.isEmergency ? '긴급' : '',
            car_workhour: String(o.car_workhour),
            car_workdaytype: String(o.car_workdaytype),
            car_worktype: String(o.work_content),
            car_height: String(o.car_height),
            crain_move_distance: String(o.move_distance),
            work_dayhour: String(parseInt(o.car_workhour, 10) || 0),
            work_dayTpe: String(o.car_workdaytype || '').trim(),
        });
    }

    /** 페이지 전용 전역 함수 (orderEdit.js 가 아닌 이 페이지에서만 쓰는 것) */
    definePageFns() {
        const o = this.o;
        const D = this.D;

        // 인라인 편집(.editor) 저장 — orderEdit.js 의 edit_save 를 이 페이지에선 토스트 표시용으로 오버라이드
        const colLabel = {
            contract_name: '거래처명',
            contract_message: '발주메모',
            order_memo: '관리메모',
            car_worktype: '작업내용',
            bonsa_col: D.extraColName || '기타',
        };
        window.edit_save = function (col, memo) {
            $.ajax({
                type: 'POST',
                url: `/adm/ajax/order/${window.ordernum}/memos`,
                data: { col: col, memo: memo },
                dataType: 'JSON',
                success: () => $j.F.Admin.Util.adminToast('success', `${colLabel[col] || col} 변경되었습니다`),
                error: () => $j.F.Admin.Util.adminToast('error', `${colLabel[col] || col} 저장 실패`),
            });
        };

        // 발주자/수주자 통화 기록 후 tel: 연결
        window.record_call_log = function (orderNum, phoneNum) {
            $.ajax({
                type: 'POST',
                url: '/adm/ajax/order/' + orderNum + '/call-log',
                success: function () {
                    window.call_made_ordernum = orderNum;
                    // CS팀이 모바일로 관리자 페이지 접속 시 바로 통화되도록
                    document.location.href = 'tel:' + phoneNum;
                },
            });
        };

        const self = this;
        // 발주 페이지 보이기 — 발주자 계정으로 프록시 로그인해서 연다.
        // (일지 버튼이 세션을 수주자로 바꿔놨을 수 있으므로 매번 발주자로 되돌린다)
        window.switchBal = function () {
            self.showPreview();
            $('#iframe_boxobj').attr('src', $j.F.Admin.Util.getUserBal(o.order_owner_num, o.num));
            self.proxyMbNo = parseInt(o.order_owner_num, 10) || 0;
            self.previewView = 'bal';
            self.setWho('bal');
        };

        // 일지 페이지 보이기 — 'bal'(발주자) / 'work'(수주자) 각각 그 사람 계정으로 프록시 로그인해서 연다.
        // 일지는 로그인한 회원 기준으로 그려지므로 계정을 바꾸지 않으면 둘 다 발주자 일지가 나온다.
        // 인자를 안 주면 미리보기 탭에서 고른 사람([발주자|수주자])의 일지를 연다.
        window.switchDiary = function (who) {
            who = who || self.who;
            const mbNo = who === 'work'
                ? parseInt(o.worker_owner_num, 10) || 0
                : parseInt(o.order_owner_num, 10) || 0;
            if (!mbNo) { $j.F.Admin.Util.adminToast('error', '수주자가 없어 일지를 열 수 없습니다'); return; }

            self.showPreview();
            const back = encodeURIComponent(`/m/diary?showipicknum=${o.num}`);
            $('#iframe_boxobj').attr('src', `/m/login/proxy?work_num=${mbNo}&returnurl=${back}`);
            // 대리로그인 세션은 브라우저 하나에 하나뿐이다 — 수주자로 바꾼 채 두면 같은 브라우저의
            // 기사관리 포털까지 수주자가 된다. 지금 누구로 들어가 있는지 기억해뒀다가 창을 닫을 때 되돌린다.
            self.proxyMbNo = mbNo;
            self.previewView = 'diary';
            self.setWho(who === 'work' ? 'work' : 'bal');
        };

        // 작업확인서 — A4 문서(HTML) 조회·재생성 화면(/adm/order/confirmation)을 별도 창으로
        window.openConfirmation = function () {
            const w = Math.min(900, screen.availWidth), h = Math.min(1000, screen.availHeight);
            const win = window.open(`/adm/order/confirmation?orderno=${o.num}`, 'manage_order_confirmation',
                `toolbar=no,status=no,width=${w},height=${h},top=0,directories=no,scrollbars=yes,location=no,resizable=yes,menubar=no`);
            if (win) win.focus();
        };

        // 발주자 변경 (⚠️위험) — 발주자 라벨 클릭 시 소유자 검색 후 교체 모달
        window.baljooja_form = function () {
            $j.Ui.JBModal.target('order-baljooja-modal', {
                target: '$j.F.Admin.Order.BaljoojaForm',
                data: {
                    ordernum:    o.num,
                    curOwnerNum: o.order_owner_num,
                    curName:     o.bal_owner_name,
                    curPhone:    o.bal_owner_phone,
                },
                title: '⚠️ 발주자 변경',
                width: '540px',
            });
        };
    }

    /** 우측 영역을 모바일 미리보기(iframe)로 전환 */
    showPreview() {
        const settle = document.getElementById('oh-settle');
        const prev = document.getElementById('moreorderdiv');
        if (settle) settle.style.display = 'none';
        if (prev) prev.style.display = 'flex';
    }

    /** 우측 영역을 정산 내역 패널로 전환 (온디맨드 로드) */
    showSettle() {
        const panel = document.getElementById('oh-settle');
        const prev = document.getElementById('moreorderdiv');
        panel.innerHTML = `<div class="oh-settle__loading">정산 내역 불러오는 중…</div>`;
        prev.style.display = 'none';
        panel.style.display = 'flex';
        $.getJSON(`/adm/ajax/order/${window.ordernum}/settlement`)
            .done((res) => { panel.innerHTML = this.renderSettle(res); })
            .fail(() => { panel.innerHTML = `<div class="oh-settle__loading">불러오기 실패</div>`; });
    }

    /** 정산 내역 렌더 (포인트 / -6차 / 발주개수 / 캐시) */
    renderSettle(d) {
        const fmt = (n) => { const v = Number(n) || 0; return (v > 0 ? '+' : '') + v.toLocaleString(); };
        const when = (s) => (s ? String(s).slice(5, 16) : '');

        // 포인트/발주개수/캐시 — ±point 원장 행
        const ledgerRows = (list) => list.map(r => `<div class="oh-sl__row">`
            + `<div class="oh-sl__main"><span class="oh-sl__desc">${OrderHandle.esc(r.rel_desc || r.rel_action || '-')}</span>`
            + `<span class="oh-sl__who">${$j.F.Admin.Member.Pop.cell(r.mb_no, r.mem_name)}</span></div>`
            + `<div class="oh-sl__side"><span class="oh-sl__pt ${Number(r.point) < 0 ? 'is-minus' : 'is-plus'}">${fmt(r.point)}</span>`
            + `<span class="oh-sl__time">${when(r.datetime)}</span></div>`
            + `</div>`).join('');

        // -6차 (g5_msix) — 발급/사용 상태 + N일차 (사용오더는 정산창 링크)
        const msixStatus = (r) => r.usedOrder
            ? `${OrderHandle.esc(r.status)}(#<a href="javascript:$j.p.openOrder(${r.usedOrder},'settle')">${r.usedOrder}</a>)`
            : OrderHandle.esc(r.status);
        const issuedLabel = (r) => r.issuedOrder
            ? `발급 #<a href="javascript:$j.p.openOrder(${r.issuedOrder},'settle')">${r.issuedOrder}</a> ${r.date || ''}`
            : `발급 ${r.date || ''}`;
        const msixRows = (list) => list.map(r => `<div class="oh-sl__row">`
            + `<div class="oh-sl__main"><span class="oh-sl__desc">${OrderHandle.esc(r.desc)}${r.status ? ` · ${msixStatus(r)}` : ''}</span>`
            + `<span class="oh-sl__who">${$j.F.Admin.Member.Pop.cell(r.mb_no, r.mem_name)} · ${issuedLabel(r)}${r.memo ? ` · ${OrderHandle.esc(r.memo)}` : ''}</span></div>`
            + `<div class="oh-sl__side"><span class="oh-sl__dayno is-clickable" onclick="$j.p.showMsixLog(${r.msixNum})" title="라이프사이클 로그 보기">${r.dayNo}일차</span></div>`
            + `</div>`).join('');

        const sec = (title, list, inner, showCnt = true) => `<div class="oh-sl__sec">`
            + `<div class="oh-sl__title">${title}${showCnt ? `<span class="oh-sl__cnt">${list.length}건</span>` : ''}</div>`
            + inner(list)
            + `</div>`;

        // 포인트는 항상, 나머지(-6차/발주개수/캐시/캐시홀드)는 존재할 때만 (제목도 숨김)
        // 자원 이름은 회원화면(/m/msix·/m/point)과 같은 아이템 뱃지로 — 상담 때 같은 물건을 가리키게 된다.
        const item = (k) => $j.Common.Util.resItem(k);
        let body = '';
        body += sec(`${item('pt')} 수주·활동`, d.points || [], (l) => l.length ? ledgerRows(l) : `<div class="oh-sl__empty">내역 없음</div>`);
        if (d.msix && d.msix.length) body += sec(item('msix'), d.msix, msixRows);
        if (d.odrcnt && d.odrcnt.length) body += sec(item('odr'), d.odrcnt, ledgerRows);
        if (d.cash && d.cash.length) body += sec('캐시 (수수료·금액변경)', d.cash, ledgerRows);
        if (d.cashHold && d.cashHold.length) {
            const holds = d.cashHold.map(r => ({ ...r, rel_desc: Number(r.point) < 0 ? '홀드(수주 차감)' : '홀드(발주 입금)' }));
            body += sec('캐시 홀드', holds, ledgerRows);
        }

        return `<div class="oh-settle__head">오더 정산 내역</div><div class="oh-settle__body">${body}</div>`;
    }

    /** 초기 렌더 후 지도·달력·인라인편집·iframe·언로드 핸들러 설정 */
    initView() {
        const { o } = this;

        $j.Common.Form.registerPhoneHandler('typech_workerPhone');   // 외부배차 작업자 전화 (하이픈 자동)

        // 사진이 없어 지도 탭으로 열렸으면 지도를 그린다 (사진 탭이면 탭을 누를 때 그린다)
        if (this.fieldTab === 'map') this.renderMap();

        // ＋ 선택 메뉴는 바깥을 누르면 닫는다 (destroy 에서 떼려고 핸들러를 필드에 둔다)
        this._onDocClick = (e) => {
            if (!e.target.closest('.oh-upmenu')) this.closeUpMenu();
        };
        document.addEventListener('click', this._onDocClick);

        // 관리자 사진등록 — $j.F.Upload 가 /api/upload 를 끝내면 여기로 돌아온다
        $j.Common.EventBus.on($j.getNS(this), 'upload:image', (e, payload) => {
            if ($j.F.Upload.getContext() !== 'ohPhoto') return;
            const files = Array.isArray(payload) ? payload : [payload];
            files.forEach(f => f && f.id && this.savePhoto(f.id));
        });

        // 창을 닫거나 새로고침하면 대리로그인을 발주자로 되돌린다 (수주자 일지를 본 경우)
        this._onPageHide = () => this.restoreBalProxy();
        window.addEventListener('pagehide', this._onPageHide);

        $('#serchdatest').mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            buttons: [], // 설정 버튼 제거
        });

        edit_fn();

        $('#iframe_boxobj').attr('src', $j.F.Admin.Util.getUserBal(o.order_owner_num, o.num));

        // 우측 영역 기본값: ?right=settle 이면 정산, 아니면 발주 미리보기(기본)
        if (new URLSearchParams(location.search).get('right') === 'settle') this.showSettle();

        // 화면색은 블루 고정 — 라이트/블루 토글 버튼은 걷어냈다 (2026-08)
        const root = document.getElementById('order-handle-root');
        if (root) root.classList.add('theme-blue');

        // 하단 액션 툴바 접힘 상태 (저장된 값, 기본 펼침)
        this.applyActions($j.Common.Store.local.get('oh-actions') === 'fold');

        // '\' 키로 접기/펼치기 — 인라인편집(.editor)·입력 중에는 무시
        this._onKeydown = (e) => {
            if (e.key !== '\\' || e.ctrlKey || e.metaKey || e.altKey) return;
            const t = e.target;
            if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
            e.preventDefault();
            this.toggleActions();
        };
        document.addEventListener('keydown', this._onKeydown);

        window.onBeforeUnload = parent_reload();

        // 팝업이 열릴 때 발주 미리보기(getUserBal)로 이미 발주자 대리로그인이 된 상태다
        this.proxyMbNo = parseInt(o.order_owner_num, 10) || 0;
    }

    /**
     * 대리로그인을 발주자로 되돌린다 — 수주자 일지를 본 뒤 창을 닫으면 세션이 수주자로 남고,
     * 같은 브라우저에서 열어둔 기사관리 포털·다른 오더핸들까지 수주자 계정이 된다.
     * redirect:'manual' — /m/login/proxy 는 세션만 바꾸면 되고 리다이렉트 목적지는 받을 필요가 없다.
     */
    restoreBalProxy() {
        const bal = parseInt(this.o.order_owner_num, 10) || 0;
        if (!bal || !this.proxyMbNo || this.proxyMbNo === bal) return;
        this.proxyMbNo = bal;
        fetch(`/m/login/proxy?work_num=${bal}`,
            { keepalive: true, credentials: 'same-origin', redirect: 'manual' }).catch(() => {});
    }

    /** 페이지 모듈 파기 — 문서에 직접 건 리스너와 EventBus 구독을 되돌린다 */
    destroy() {
        document.removeEventListener('click', this._onDocClick);
        document.removeEventListener('keydown', this._onKeydown);
        window.removeEventListener('pagehide', this._onPageHide);
        $j.Common.EventBus.offNamespace($j.getNS(this));
    }

    /** 하단 액션 툴바 접힘 적용 — 접으면 얇은 핸들만 남아 우측 미리보기 세로 공간이 넓어진다 */
    applyActions(fold) {
        const box = document.getElementById('oh-actions');
        if (!box) return;
        box.classList.toggle('is-collapsed', fold);
        const txt = box.querySelector('.oh-actions__handle-txt');
        if (txt) txt.textContent = fold ? '하단 도구 펼치기' : '하단 접기';
    }

    /** 하단 액션 툴바 접기/펼치기 토글 + 저장 */
    toggleActions() {
        const fold = $j.Common.Store.local.get('oh-actions') !== 'fold';
        $j.Common.Store.local.set('oh-actions', fold ? 'fold' : 'open');
        this.applyActions(fold);
    }

    /** 오더관리 창을 별도 창으로 연다. right='settle' 이면 우측 기본값을 정산으로. */
    openOrder(num, right) {
        $j.F.Admin.Util.openOrderHandle(num, { right: right, name: 'order_handle_' + num });
    }

    // ──────────────────────────────────────────────────────────────
    // 렌더링 헬퍼
    // ──────────────────────────────────────────────────────────────

    /** 1열(라벨/값) 인포 행 */
    row1(k, v) {
        return `<div class="oh-info__row"><div class="oh-info__cell"><div class="oh-info__k">${k}</div><div class="oh-info__v">${v}</div></div></div>`;
    }

    /** 2열(라벨/값 × 2) 인포 행 */
    row2(k, v, k2, v2) {
        return `<div class="oh-info__row">`
            + `<div class="oh-info__cell"><div class="oh-info__k">${k}</div><div class="oh-info__v">${v}</div></div>`
            + `<div class="oh-info__cell"><div class="oh-info__k">${k2}</div><div class="oh-info__v">${v2}</div></div>`
            + `</div>`;
    }

    /** 편집 가능 셀(.editor) — edit_fn() 이 클릭 시 contenteditable 로 전환 */
    editCell(col, v, opt = {}) {
        const cls = opt.multiline ? ' oh-editable--multiline' : '';
        const max = opt.maxlen ? ` data-maxlen="${opt.maxlen}"` : '';
        return `<div class="oh-info__v oh-editable editor${cls}" data-value="${col}"${max}>${OrderHandle.esc(v)}</div>`;
    }

    /** 카드 래퍼 */
    card(title, bodyHtml, opt = {}) {
        const right = opt.right || '';
        const pad0 = opt.pad0 ? ' oh-card--pad0' : '';
        const cls = opt.cls ? ` ${opt.cls}` : '';
        return `<div class="oh-card${pad0}${cls}">`
            + `<div class="oh-card__title">${title}${right ? `<span style="flex:1"></span>${right}` : ''}</div>`
            + bodyHtml
            + `</div>`;
    }

    // ──────────────────────────────────────────────────────────────
    // 렌더링 본체
    // ──────────────────────────────────────────────────────────────

    renderHtml() {
        const { o } = this;
        return `
${this.workflowForm()}
<form name="inputform" method="post" class="oh">
<input type="hidden" name="default_gps_position" id="default_gps_position" value="${Util.escapeHtml(o.site_latlng)}">
<input type="hidden" name="mappos_loc1_last"  id="mappos_loc1_last" value="">
<input type="hidden" name="mappos_loc2_last"  id="mappos_loc2_last" value="">
<input type="hidden" name="mem_basepoint" id="mem_basepoint" value="">
<input type="hidden" name="thiscartype" id="thiscartype" value="${Util.escapeHtml(o.car_type)}">

<div class="oh-grid">
    <div class="oh-col">
        ${this.orderCard()}
        ${this.fieldCard()}
    </div>
    <div class="oh-col">
        ${this.previewCard()}
        <div id="oh-settle" class="oh-settle-panel" style="display:none"></div>
    </div>
</div>

${this.actionButtons()}

<input type="text" id="emppdumy" class="han">
<div id="oh-mapbig" class="oh-mapbig" style="display:none">
    <button type="button" class="oh-mapbig__close" onclick="$j.p.closeMapBig()" aria-label="닫기">✕</button>
    <iframe id="oh-mapbig-frame" class="oh-mapbig__frame" src=""></iframe>
</div>
<div id="oh-msix-modal" class="oh-msixmodal" style="display:none">
    <div class="oh-msixmodal__box">
        <div class="oh-msixmodal__head"><span><i class="fas fa-bolt"></i> -6차 라이프사이클</span><button type="button" onclick="$j.p.closeMsixModal()" aria-label="닫기">✕</button></div>
        <div id="oh-msix-body" class="oh-msixmodal__body"></div>
    </div>
</div>
<div id="oh-mercury-modal" class="oh-msixmodal" style="display:none">
    <div class="oh-msixmodal__box oh-mc-box">
        <div class="oh-msixmodal__head"><span><i class="fas fa-share-square"></i> 머큐리 RNS 전송</span><button type="button" onclick="$j.p.closeMercury()" aria-label="닫기">✕</button></div>
        <div id="oh-mercury-body" class="oh-msixmodal__body"></div>
    </div>
</div>
${this.whanDeferBox()}
${this.whanRevertBox()}
${this.popMessageBox()}
</form>
`;
    }

    /** 상단 workflow 폼 (orderEdit.js 가 값 채워 submit) */
    workflowForm() {
        const names = ['sender_num', 'recivernum', 'mtitle', 'msg', 'ptype', 'linkurl', 'notitype',
            'OKMSG', 'ordernum', 'returl', 'notiTypedetail',
            'cenceltype', 'isitPcadmin'];
        const hidden = names.map(n => `<input type="hidden" name="${n}" value="">`).join('');
        return `<form name="workflow" action="" method="post">${hidden}<input type="hidden" name="jobcallFrom" value="ManagePc"></form>`;
    }

    /** 상태전환 버튼 (스티키 바로가기 줄 우측). 진행상태는 타이틀 배지로 이동 */
    jinhaengBlock() {
        return `<div class="oh-jinhaeng">${this.exBtn6()}</div>`;
    }

    /** 진행상태 색상 클래스 */
    statusBadgeClass() {
        if (this.D.orderStatusStr === '3분대기') return 'is-wait';
        const s = this.o.order_status;
        if (s == 99) return 'is-cancel';
        if (s >= 8) return 'is-done';
        return '';
    }

    /** 지정발주 알림중일 때만 노출되는 배차완료/어플전환 버튼 */
    exBtn6() {
        const { D, o } = this;
        if (o.order_type == 95 && o.order_status == 3) {
            if (o.direct_wait_mode == 1) {
                return `<button type="button" class="oh-btn oh-btn--warn" onclick="waitToApp(${D.ordernum})">어플전환</button>`;
            }
            return `<button type="button" class="oh-btn oh-btn--primary" onclick="changestatusto(${D.ordernum},6,${D.orderStatus})">배차완료전환</button>`;
        }
        return '';
    }

    /** 작업순서변경 select (수주대기 이후 상태에서만 노출) — 선택 즉시 checkJobChangers 실행 */
    jobChangerHtml() {
        const { o } = this;
        if (o.order_status < 4) return '';

        const opts = { 6: '배차완료', 7: '현장도착', 8: '작업완료', 9: '수금완료' };
        let sel = `<select id="joboptchanger" class="oh-select" onchange="checkJobChangers()"><option value="" selected>작업순서변경</option>`;
        for (const [v, label] of Object.entries(opts)) {
            sel += `<option value="${v}">${label}</option>`;
        }
        sel += `</select>`;
        return sel;
    }

    /** 오더 정보 카드 */
    orderCard() {
        const { D, o } = this;
        const cmm = D.isNofee ? '없음' : `${D.feeRate}%`;
        const carSpec = OrderHandle.esc(`${o.car_type || ''} ${D.carRangeStr || ''} ${o.car_option || ''}`.trim());
        const workDayH = `[${String(o.car_workdaytype || '').trim()}] ${D.workHourStr || ''}`;

        // 발주자 / 수주자 / 작업기사 이름 + 전화번호(이름보다 작게, tel 링크). 소속자면 '소유자(소속자)' (서버 balName/workerName).
        // 이름은 관리자 회원 표기(회원 팝오버)지만
        // `#번호` 는 뗀다 — 옆에 전화번호가 붙어 누구인지 이미 가려지고, 번호까지 붙이면 칸이 길어진다
        const P = $j.F.Admin.Member.Pop;
        const phone = (p) => p ? ` <a class="oh-pphone" href="tel:${Util.escapeHtml(p)}">${Util.escapeHtml(p)}</a>` : '';
        // 발주자 전화번호는 통화기록(bal_call_confirmed=1) 후 tel: 연결 — record_call_log 경유
        const callPhone = (p) => p ? ` <a class="oh-pphone" href="javascript:record_call_log(${o.num}, ${OrderHandle.jsArg(p)})">${Util.escapeHtml(p)}</a>` : '';
        const omName = `<span class="oh-pname">${P.cell(o.order_owner_num, D.balName, { name: true })}</span>` + callPhone(o.bal_owner_phone);
        const wPhone = o.order_type == 94 ? o.driver_phone : o.owner_phone;
        // 외부배차(94)의 수주자는 회원이 아니다 — 이름만 적는다
        const wName = (o.order_type == 94
            ? `<span class="oh-pname">${OrderHandle.esc(o.driver_name || '-')}</span>`
            : `<span class="oh-pname">${P.cell(o.worker_owner_num, D.workerName, { name: true })}</span>`) + phone(wPhone);

        // 작업기사: 없으면 빈칸 / 작업차량: -1(외부배차) 또는 없으면 빈칸
        const driverStr = o.bworker_name ? `<span class="oh-pname">${P.cell(o.worker_num, o.bworker_name, { name: true })}</span>${phone(o.bmemphone)}` : '';
        const carPlate = (o.car_plate && o.car_plate != '-1') ? OrderHandle.esc(o.car_plate) : '';

        const info = `<div class="oh-info">`
            + this.row2('작업일시', Util.formatDateTime(D.workTimeLabel) || '-', '소요시간', workDayH || '-')
            + this.row2('등록시간', Util.formatDateTime(D.regDateLabel) || '-', '수주시간', Util.formatDateTime(D.regTimeLabel) || '-')
            + this.row1('기종/옵션', carSpec || '-')
            + this.row2('수수료율', `<span class="oh-strong-red">${cmm}</span>`, '결제책임', D.howtopayStr || '-')
            + this.row2('가격', `<span class="oh-num">${Util.formatNumber(o.car_price)}</span>원`, '업체가격', `<span class="oh-num">${Util.formatNumber(o.car_price_bonsa)}</span>원`)
            + this.row2(`<span class="oh-baljooja-k" onclick="baljooja_form()">발주자</span>`, omName, '수주자', wName)
            + this.row2('작업기사', driverStr, '작업차량', carPlate)
            + `<div class="oh-info__row">`
            + `<div class="oh-info__cell"><div class="oh-info__k">작업내용</div>${this.editCell('car_worktype', o.work_content, { multiline: true, maxlen: D.workContentMax })}</div>`
            + `<div class="oh-info__cell"><div class="oh-info__k">현장번호</div><div class="oh-info__v">${OrderHandle.esc(o.site_phone)}</div></div>`
            + `</div>`
            + `<div class="oh-info__row">`
            + `<div class="oh-info__cell oh-memo"><div class="oh-info__k">거래처명</div>${this.editCell('contract_name', o.client_name)}</div>`
            + `<div class="oh-info__cell"><div class="oh-info__k">거래처번호</div><div class="oh-info__v">${OrderHandle.esc(o.client_phone)}</div></div>`
            + `</div>`
            // 메모 (전부 펼침)
            + this.memoRow('발주메모', 'contract_message', o.request_note)
            + this.memoRow('관리메모', 'order_memo', o.admin_memo)
            + this.memoRow(D.extraColName || '기타', 'bonsa_col', D.bonsaCol)
            + `</div>`;

        const title = `오더 정보 <span class="oh-titleno">#${o.num}</span>`
            + `<span class="oh-statusbadge ${this.statusBadgeClass()}">${D.orderStatusStr}</span>`
            + `<span class="oh-titlebadge">${D.orderTypeStr || '-'}</span>`
            + (D.matchTypeStr ? `<span class="oh-titlebadge oh-titlebadge--match">${D.matchTypeStr}</span>` : '')
            + (Number(o.whan_status) === 1 ? `<span class="oh-titlebadge oh-titlebadge--whan">환원보류</span>` : '');
        // 취소 오더는 전체적으로 희미하게
        const cls = o.order_status == 99 ? 'is-cancelled' : '';
        return this.card(title, info, { pad0: true, cls });
    }

    /** 메모 행 (전체폭 편집 셀) */
    memoRow(k, col, v) {
        return `<div class="oh-info__row oh-memo"><div class="oh-info__cell">`
            + `<div class="oh-info__k">${k}</div>${this.editCell(col, v)}</div></div>`;
    }

    /**
     * 작업 현장 카드 — 타이틀 줄은 현장주소 + [지도|사진] 탭.
     * 본문은 탭에 따라 지도이거나 썸네일이다 (초기 탭은 initialize 에서 사진 유무로 결정).
     */
    fieldCard() {
        const { o } = this;
        const title = `현장 <span class="oh-titlesub">${OrderHandle.esc(o.site_address || '-')}</span>`;
        const right = `<span class="oh-tabs" id="oh-field-tabs">${this.fieldTabs()}</span>`;
        // cls — ＋ 선택 메뉴(작업 전·중·후)가 카드 밖으로 떨어져도 잘리지 않게 (.oh-card 는 overflow:hidden)
        // 본문 높이는 .oh-field-body 가 고정한다 — 탭을 바꿔도 카드 크기가 안 변해야 한다
        return this.card(title, `<div class="oh-card__body oh-field-body" id="oh-field-body">${this.fieldBody()}</div>`,
            { right, cls: 'oh-card--menu' });
    }

    /** [지도|사진] 탭 버튼 — 탭을 바꾸면 이 부분만 다시 그려 활성표시를 옮긴다 */
    fieldTabs() {
        const tab = (k, label) =>
            `<button type="button" class="oh-tab${this.fieldTab === k ? ' is-on' : ''}"`
            + ` onclick="$j.p.showField('${k}')">${label}</button>`;
        return tab('map', '지도') + tab('photo', '사진');
    }

    /** 등록된 사진·서류가 한 장이라도 있나 (초기 탭 결정 — 있으면 사진, 없으면 지도) */
    hasPhoto() {
        const p = this.D.photos || {};
        return ((p.doc || []).length + (p.work || []).length + (p.settle || []).length) > 0;
    }

    /**
     * 탭 전환 — 본문과 탭 버튼만 다시 그린다 (미리보기 iframe 을 건드리지 않으려고).
     * 지도는 DOM 이 새로 생길 때마다 다시 그려야 한다 (카카오맵은 빈 div 에 붙는다).
     */
    showField(tab) {
        if (this.fieldTab === tab) return;
        this.fieldTab = tab;
        document.getElementById('oh-field-body').innerHTML = this.fieldBody();
        document.getElementById('oh-field-tabs').innerHTML = this.fieldTabs();
        if (tab === 'map') this.renderMap();
    }

    /**
     * 현장 지도 — 예전 mapCard 자리로 돌아온 인라인 카카오맵.
     * gps 가 없으면(주소 미확정 오더) 안내만 남긴다.
     */
    renderMap() {
        const el = document.getElementById('workField');
        if (!el) return;
        const lat = parseFloat(window.gps1), lng = parseFloat(window.gps2);
        if (!lat || !lng || !window.daum || !daum.maps) {
            el.innerHTML = `<span class="oh-map__none">좌표가 없어 지도를 표시할 수 없습니다</span>`;
            return;
        }
        const pos = new daum.maps.LatLng(lat, lng);
        const map = new daum.maps.Map(el, { center: pos, level: 3 });
        new daum.maps.Marker({ position: pos }).setMap(map);
    }

    /** 지도 확대 — 창 내 오버레이로 /map/full 표시 */
    openMapBig() {
        const ov = document.getElementById('oh-mapbig');
        document.getElementById('oh-mapbig-frame').src = `/map/full?gps=${window.gps}`;
        ov.style.display = 'flex';
    }

    /** 지도 확대 오버레이 닫기 */
    closeMapBig() {
        const ov = document.getElementById('oh-mapbig');
        ov.style.display = 'none';
        document.getElementById('oh-mapbig-frame').src = '';
    }

    /**
     * 현장 카드 본문 — 탭에 따라 지도 또는 썸네일. 사진 등록 후에도 이 부분만 다시 그린다.
     * 줄 = phototype. 각 줄 끝의 ＋ 로 그 줄의 종류를 관리자가 직접 올린다.
     * (작업확인서는 하단 '작업확인서' 버튼의 전용 화면에서 따로 만든다)
     */
    fieldBody() {
        if (this.fieldTab === 'map') {
            return `<div class="oh-mapwrap">`
                + `<div id="workField" class="oh-map"></div>`
                + `<button type="button" class="oh-map__zoom" onclick="$j.p.openMapBig()" title="확대" aria-label="지도 확대">`
                + `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">`
                + `<path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>`
                + `</button></div>`;
        }

        const { photos = {}, isInsurance } = this.D;
        // 정산서류 줄은 보험정산 오더에만 상시로 세운다 (일반 오더는 이미 등록된 게 있을 때만)
        const showSettle = isInsurance || (photos.settle || []).length > 0;
        return this.thumbRow('작업문서', photos.doc, ['doc'])
             + this.thumbRow('현장사진', photos.work, ['before', 'during', 'after'])
             + (showSettle ? this.thumbRow('정산서류', photos.settle, ['license', 'bank']) : '');
    }

    /** 썸네일 한 줄 — 사진 클릭은 뷰어 팝업, 줄 끝 ＋ 는 그 줄 종류로 업로드 */
    thumbRow(label, list, kinds) {
        // n=0 은 전자작업확인서 아이콘 — 사진이 아니라 잘리면 안 되므로 contain 으로 둔다
        const items = (list || []).map(p =>
            `<span class="oh-thumbwrap">`
            + `<img class="oh-thumb${p.n === 0 ? ' oh-thumb--doc' : ''}" src="${p.thumb}" loading="lazy" alt="" onclick="$j.p.showPic(${p.n})">`
            + (p.tag ? `<span class="oh-thumb__tag">${OrderHandle.esc(p.tag)}</span>` : '')
            + `</span>`).join('');
        // 비어 있어도 ＋ 가 자리를 지키므로 '없음' 자리표시는 두지 않는다
        return `<div class="oh-thumbs">`
            + `<span class="oh-thumbs__k">${label}</span>`
            + `<div class="oh-thumbs__list">${items}${this.addBtn(kinds)}</div>`
            + `</div>`;
    }

    /**
     * 줄 끝 ＋ 버튼 — 배차유형과 무관하게 모든 오더에 붙는다.
     * 외부배차는 올릴 수주자(회원)가 아예 없어서 필수였고, 일반 오더도 기사가 못 올렸거나
     * 잘못 올린 경우 CS 가 대신 채워 넣어야 하므로 같은 자리에서 받는다.
     * 종류가 여럿인 줄(현장사진 전·중·후, 정산서류)은 ＋ 를 누르면 고르는 메뉴가 뜬다.
     */
    addBtn(kinds) {
        if (!kinds || !kinds.length) return '';

        const plus = (attr) => `<button type="button" class="oh-upbtn" title="사진 추가" ${attr}>＋</button>`;
        if (kinds.length === 1) return plus(`onclick="$j.p.pickPhoto('${kinds[0]}')"`);

        const names = this.D.photoKinds || {};
        const items = kinds.map(k =>
            `<button type="button" onclick="$j.p.pickPhoto('${k}')">${names[k] || k}</button>`).join('');
        return `<span class="oh-upmenu">${plus(`onclick="$j.p.toggleUpMenu(this)"`)}`
            + `<span class="oh-upmenu__list">${items}</span></span>`;
    }

    /** ＋ 선택 메뉴 열고 닫기 (한 번에 하나만) */
    toggleUpMenu(btn) {
        const wrap = btn.parentNode;
        const open = wrap.classList.contains('is-open');
        this.closeUpMenu();
        if (!open) wrap.classList.add('is-open');
    }

    closeUpMenu() {
        document.querySelectorAll('.oh-upmenu.is-open').forEach(el => el.classList.remove('is-open'));
    }

    /** 사진 고르기 — 업로드 완료는 EventBus('upload:image') 로 돌아온다 */
    pickPhoto(kind) {
        this.closeUpMenu();
        this.upKind = kind;
        $j.F.Upload.addPhotoHere({
            // diary1(현장사진)/diary2(작업문서·서류) — 업로드 서버의 파일 구분값
            tag: ['before', 'during', 'after'].includes(kind) ? 'diary1' : 'diary2',
            context: 'ohPhoto',
            max_sheet: 1,
            id: this.D.ordernum,
        });
    }

    /** 업로드된 이미지를 오더에 붙인다 */
    savePhoto(imgId) {
        $.post(`/adm/ajax/order/${this.D.ordernum}/photos`,
            { kind: this.upKind, img_id: imgId },
            (r) => {
                if (!r || !r.result) {
                    $j.F.Admin.Util.adminToast('error', (r && r.message) || '등록 실패');
                    return;
                }
                this.D.photos = r.photos;
                this.fieldTab = 'photo';   // 방금 올린 걸 바로 보여준다
                document.getElementById('oh-field-body').innerHTML = this.fieldBody();
                document.getElementById('oh-field-tabs').innerHTML = this.fieldTabs();
                $j.F.Admin.Util.adminToast('success', '등록되었습니다');
            }, 'json');
    }

    /** 사진 뷰어 팝업 (n=0 은 전자작업확인서 — 1차만 본다) */
    showPic(n) {
        $j.F.Order.ListTable.showPic(this.D.ordernum, n, 1);
    }

    /** -6차 라이프사이클 로그 모달 열기 (온디맨드) */
    showMsixLog(msixNum) {
        const body = document.getElementById('oh-msix-body');
        body.innerHTML = `<div class="oh-msx-empty">불러오는 중…</div>`;
        document.getElementById('oh-msix-modal').style.display = 'flex';
        $.getJSON(`/adm/ajax/msix/${msixNum}/logs`)
            .done((d) => { body.innerHTML = this.renderMsixLog(d); })
            .fail(() => { body.innerHTML = `<div class="oh-msx-empty">불러오기 실패</div>`; });
    }

    closeMsixModal() {
        document.getElementById('oh-msix-modal').style.display = 'none';
    }

    /** -6차 액션 → 색상 클래스 */
    msixActClass(a) {
        if (a === '발급') return 'issue';
        if (a === '사용') return 'use';
        if (String(a).indexOf('취소') === 0) return 'cancel';
        if (a === '전환') return 'convert';
        if (a === '회수') return 'recover';
        return '';
    }

    /** -6차 로그 렌더 */
    renderMsixLog(d) {
        const m = d.msix;
        const dt = (s) => (s ? String(s).slice(0, 16).replace('T', ' ') : '');
        const uoStr = (uo) => {
            const v = Number(uo);
            if (uo === null || uo === '') return '미사용';
            if (v === -1) return '오더취소'; if (v === -2) return '발주개수 전환';
            if (v === -3) return '관리자 회수'; if (v > 0) return `수주 사용(#${v})`;
            return '';
        };
        const head = m ? `<div class="oh-msx-sum">`
            + `<b>${$j.F.Admin.Member.Pop.cell(m.mb_no, m.mem_name)}</b>`
            + `<span>발급오더 #${m.ordernum || '-'}</span>`
            + `<span>시작 ${m.start_date || '-'}</span>`
            + `<span>현재 ${uoStr(m.used_ordernum)}</span>`
            + `</div>` : '';

        const rows = (d.logs && d.logs.length)
            ? d.logs.map((l) => `<div class="oh-msx-row">`
                + `<span class="oh-msx-act is-${this.msixActClass(l.action)}">${OrderHandle.esc(l.action)}</span>`
                + `<div class="oh-msx-meta">`
                + `<span class="oh-msx-dt">${dt(l.datetime)}</span>`
                + (l.nday != null ? `<span class="oh-msx-tag">${l.nday}일차</span>` : '')
                + (Number(l.ref_ordernum) > 0 ? `<span class="oh-msx-tag">오더 #${l.ref_ordernum}</span>` : '')
                + (l.start_date ? `<span class="oh-msx-tag">시작 ${l.start_date}</span>` : '')
                + (l.memo ? `<span class="oh-msx-memo">${OrderHandle.esc(l.memo)}</span>` : '')
                + `</div></div>`).join('')
            : `<div class="oh-msx-empty">기록된 이력이 없습니다.<br><span class="oh-msx-note">(이 기능 추가 이전 발생분은 이력이 없습니다)</span></div>`;

        return head + `<div class="oh-msx-list">${rows}</div>`;
    }

    // ──────────────────────────────────────────────────────────────
    // 머큐리 RNS 전송 (보험 정산 소속 오더 전용)
    // ──────────────────────────────────────────────────────────────

    /**
     * 관리 줄의 [머큐리] 버튼 — 보험 정산 소속(화물공제·KB)에만 세운다.
     * 일반 오더에는 보낼 곳이 없으므로 버튼 자체를 만들지 않는다.
     */
    mercuryBtn() {
        if (!this.D.isInsurance) return '';
        // 도움말은 관리줄의 다른 버튼과 같은 방식(hover 툴팁)으로 맞춘다 — 브라우저 기본 title 은
        // 뜨는 데 1초 넘게 걸리고 생김새도 혼자 다르다.
        return `<button type="button" class="oh-btn oh-btn--info" onclick="$j.p.showMercury()"`
            + OrderHandle.tipAttr('머큐리', '보험 정산 소속(화물공제조합·KB손해보험) 오더의 RNS 전송현황을 보고 다시 보낸다.')
            + `>머큐리</button>`;
    }

    /** 전송현황 모달 열기 (온디맨드) */
    showMercury() {
        const body = document.getElementById('oh-mercury-body');
        body.innerHTML = `<div class="oh-msx-empty">불러오는 중…</div>`;
        document.getElementById('oh-mercury-modal').style.display = 'flex';
        $.getJSON(`/adm/ajax/order/${this.D.ordernum}/mercury`)
            .done((d) => { body.innerHTML = this.renderMercury(d); })
            .fail(() => { body.innerHTML = `<div class="oh-msx-empty">불러오기 실패</div>`; });
    }

    closeMercury() {
        document.getElementById('oh-mercury-modal').style.display = 'none';
    }

    /**
     * 재전송 실행. 대상은 auto|order|estimate|images|all —
     * auto 는 서버(MercurySyncService::resolveTargets)가 오더상태로 정한다.
     */
    sendMercury(type) {
        const box = document.getElementById('oh-mc-result');
        const btns = document.querySelectorAll('#oh-mercury-body .oh-mc-send');
        btns.forEach(b => { b.disabled = true; });
        box.innerHTML = `<div class="oh-mc-note">전송 중…</div>`;

        $.post(`/adm/ajax/order/${this.D.ordernum}/mercury`, { type: type }, (r) => {
            btns.forEach(b => { b.disabled = false; });
            box.innerHTML = this.mercuryResults(r);
            if (r.history) {
                const hist = document.getElementById('oh-mc-hist');
                if (hist) hist.innerHTML = this.mercuryHistory(r.history);
            }
            $j.F.Admin.Util.adminToast(r.result ? 'success' : 'error', r.message || (r.result ? '전송했습니다' : '전송 실패'));
        }, 'json').fail(() => {
            btns.forEach(b => { b.disabled = false; });
            box.innerHTML = `<div class="oh-mc-note is-fail">요청 실패</div>`;
            $j.F.Admin.Util.adminToast('error', '전송 요청 실패');
        });
    }

    /** 모달 본문 — 요약 · 전송대상 버튼 · 결과 · 전송이력 */
    renderMercury(d) {
        const e = (s) => OrderHandle.esc(s);
        const auto = (d.autoTargets || []).join('+') || '오더';

        const sum = `<div class="oh-msx-sum">`
            + `<b>${e(d.insuName) || '보험사 없음'}</b>`
            + `<span>접수번호 ${e(d.receiptNo) || '-'}</span>`
            + `<span>계산서 ${e(d.invoice)}</span>`
            + `<span>${e(d.statusStr)}</span>`
            + `<span>${Util.formatNumber(d.carPrice)}원</span>`
            + `</div>`;

        // 오더 페이로드가 안 만들어지면(접수번호 없음 등) 전송해도 실패한다 — 먼저 알린다
        const err = (d.payload && d.payload._error)
            ? `<div class="oh-mc-note is-fail">전송 불가 : ${e(d.payload._error)}</div>` : '';

        const btn = (type, label, cls) =>
            `<button type="button" class="oh-btn ${cls} oh-mc-send" onclick="$j.p.sendMercury('${type}')">${label}</button>`;

        const send = `<div class="oh-mc-send-row">`
            + btn('auto', `자동 (${e(auto)})`, 'oh-btn--primary')
            + btn('order', '오더', 'oh-btn--ghost')
            + btn('estimate', '청구서', 'oh-btn--ghost')
            + btn('images', '정산서류', 'oh-btn--ghost')
            + btn('all', '전체', 'oh-btn--warn')
            + `</div>`;

        // 상대가 "값이 이상하다"고 할 때 실제로 무엇을 보내는지 여기서 바로 확인한다
        const payload = (d.payload && !d.payload._error)
            ? `<details class="oh-mc-pay"><summary>보낼 오더 내용 보기</summary>`
              + `<pre>${e(JSON.stringify(d.payload, null, 2))}</pre></details>` : '';

        return sum + err + send
            + `<div id="oh-mc-result"></div>`
            + payload
            + `<div class="oh-mc-histhead">전송이력`
            + `<span class="oh-msx-note">벤더로그는 1년 뒤 삭제됩니다 — 비어 있다고 미전송은 아닙니다</span></div>`
            + `<div id="oh-mc-hist" class="oh-mc-hist">${this.mercuryHistory(d.history)}</div>`;
    }

    /** 재전송 결과 — 대상별 한 줄 */
    mercuryResults(r) {
        const e = (s) => OrderHandle.esc(s);
        if (!r.results || !r.results.length) {
            return `<div class="oh-mc-note is-fail">${e(r.message) || '전송하지 못했습니다.'}</div>`;
        }
        return r.results.map((t) => {
            const cls = t.dev ? 'is-dev' : (t.ok ? 'is-ok' : 'is-fail');
            const mark = t.dev ? '개발' : (t.ok ? '성공' : '실패');
            return `<div class="oh-mc-row ${cls}">`
                + `<span class="oh-mc-badge">${mark}</span>`
                + `<span class="oh-mc-tgt">${e(t.label)}</span>`
                + `<span class="oh-mc-msg">HTTP ${t.status} · ${e(t.message)}</span>`
                + `</div>`;
        }).join('');
    }

    /** 전송이력 목록 (최근 30건, 최신순) */
    mercuryHistory(list) {
        const e = (s) => OrderHandle.esc(s);
        if (!list || !list.length) {
            return `<div class="oh-msx-empty">남아있는 전송이력이 없습니다.</div>`;
        }
        return list.map((h) => `<div class="oh-mc-row ${h.dev ? 'is-dev' : (h.ok ? 'is-ok' : 'is-fail')}">`
            + `<span class="oh-mc-badge">${h.dev ? '개발' : (h.ok ? '성공' : '실패')}</span>`
            + `<span class="oh-mc-tgt">${e(h.endpoint)}</span>`
            + `<span class="oh-mc-msg">${e(String(h.time).slice(0, 19))} · ${e(h.message)}</span>`
            + `</div>`).join('');
    }

    /**
     * 버튼에 붙이는 hover 도움말 속성 한 벌.
     *
     * **hover 전용이다**(data-tip-hover). 이 줄의 버튼들은 눌리면 실제로 뭔가 일어나므로,
     * 클릭으로도 툴팁이 토글되면 방금 연 모달 위에 설명이 남아 화면을 가린다 (Ui/Tooltip.js).
     * `"` 까지 막아야 속성이 안 깨지므로 esc() 를 그대로 쓰지 않는다.
     */
    static tipAttr(title, text) {
        const a = (v) => OrderHandle.esc(v).replace(/"/g, '&quot;');
        return ` data-tip-hover data-tip-title="${a(title)}" data-tip="${a(text)}"`;
    }

    /** onclick="f(…)" 같은 인라인 핸들러에 문자열 인자로 넣을 때 — JS 리터럴로 만든 뒤 속성 이스케이프 */
    static jsArg(s) {
        return Util.escapeHtml(JSON.stringify(String(s ?? '')));
    }

    /** HTML 엔티티 이스케이프 — 보험사명·응답본문 등 외부 문자열을 innerHTML 로 넣을 때 */
    static esc(s) {
        const d = document.createElement('div');
        d.appendChild(document.createTextNode(s === null || s === undefined ? '' : String(s)));
        return d.innerHTML;
    }

    /**
     * 발주 미리보기 iframe (#iframe_boxobj — getUserBal 모바일웹 로딩 → 모바일 화면 비율 유지).
     * 화면 위에 겹쳐 뜨는 표식(.oh-who)은 지금 누구 계정으로 대리로그인해 보고 있는지를 적는다 —
     * 발주자 앱과 수주자 앱은 화면이 비슷해서 표시가 없으면 어느 쪽을 보는지 알 수 없다.
     * 계정을 바꾸는 조작은 하단 바로가기 줄의 [발주자|수주자] 탭이다 (whoTabs).
     */
    previewCard() {
        return `<div id="moreorderdiv" class="oh-phone">`
            + `<span class="oh-who" id="oh-who">${this.whoLabel('bal')}</span>`
            + `<div id="inside_orderdiv">`
            + `<iframe name="iframe_boxobj" id="iframe_boxobj" class="oh-frame" src=""></iframe>`
            + `</div></div>`;
    }

    /**
     * 미리보기 계정 [발주자|수주자] 탭 — 현장 카드의 [지도|사진] 과 같은 조작이다.
     * 옛 '수일지' 버튼 자리(하단 바로가기 줄 끝)에 두어, 사람을 고른 뒤 일지·발주를 누르게 한다.
     * 활성 쪽 색으로 지금 보고 있는 계정을 구분한다 (발주자 노랑 / 수주자 초록).
     * 수주 전·외부배차(수주자 회원번호 없음)면 수주자 쪽은 흐리게 (클릭은 살려두고 토스트로 안내).
     */
    whoTabs() {
        const tab = (k, label) =>
            `<button type="button" class="oh-whotab${this.who === k ? ' is-on' : ''}`
            + `${k === 'work' && !this.hasWorker() ? ' is-off' : ''}" data-who="${k}"`
            + ` onclick="$j.p.switchWho('${k}')">${label}</button>`;
        return tab('bal', '발주자') + tab('work', '수주자');
    }

    /** 하단 바로가기 줄에 들어가는 탭 묶음 (활성표시만 다시 그리려고 id 를 단다) */
    whoTabsBox() {
        return `<span class="oh-whotabs" id="oh-whotabs" title="미리보기·일지를 누구 계정으로 볼지">`
            + `${this.whoTabs()}</span>`;
    }

    /** 수주자 회원번호가 있나 (수주 전·외부배차면 없다) */
    hasWorker() {
        return (parseInt(this.o.worker_owner_num, 10) || 0) > 0;
    }

    /**
     * 미리보기 계정 전환 — 보던 화면(발주/일지)은 그대로 두고 사람만 바꾼다.
     * 수주자에게는 발주(오더수정) 화면이 없으므로, 발주를 보던 중이면 수주자 일지로 넘어간다.
     */
    switchWho(who) {
        if (who === this.who) return;
        if (who === 'work' && !this.hasWorker()) { $j.F.Admin.Util.adminToast('error', '수주자가 없어 수주자 화면을 열 수 없습니다'); return; }

        if (who === 'bal' && this.previewView === 'bal') window.switchBal();
        else window.switchDiary(who);
    }

    /**
     * 미리보기가 누구 앱인지 알리는 표식 — 'bal' 발주자 / 'work' 수주자.
     * 자리를 차지하면 미리보기가 그만큼 줄어드니 iframe 위에 겹쳐 띄운다 (글자만, 이름 없음).
     * 수주자일 때는 색을 바꿔(초록) 발주자 화면과 갈라놓는다.
     */
    whoLabel(who) {
        const isWork = who === 'work';
        return `<span class="oh-who__tag${isWork ? ' is-work' : ''}">${isWork ? '수주자' : '발주자'}</span>`;
    }

    /** 미리보기 계정을 기억하고, 표식과 탭 활성표시를 함께 옮긴다 */
    setWho(who) {
        this.who = who === 'work' ? 'work' : 'bal';
        const tag = document.getElementById('oh-who');
        if (tag) tag.innerHTML = this.whoLabel(this.who);
        const tabs = document.getElementById('oh-whotabs');
        if (tabs) tabs.innerHTML = this.whoTabs();
    }

    /** 하단 액션 툴바 */
    actionButtons() {
        return `<div class="oh-actions" id="oh-actions"><div class="oh-actions__body">${this.actionsBody()}</div></div>`;
    }

    /**
     * 접기 버튼 — 바로가기 줄 맨 끝(빈 공간)에 얹어 툴바 높이를 늘리지 않는다.
     * 접히면 같은 자리에 이 버튼만 남으므로 접기/펼치기 시 버튼이 움직이지 않는다.
     */
    foldBtn() {
        return `<button type="button" class="oh-actions__handle" onclick="$j.p.toggleActions()" title="하단 영역 접기/펼치기 (\\ 키)">`
            + `<span class="oh-actions__chev">▼</span><span class="oh-actions__handle-txt">하단 접기</span>`
            + `</button>`;
    }

    /** 액션 툴바 본문 (바로가기 / 요청 / 관리 / 매칭발송) */
    actionsBody() {
        const { D, o } = this;
        const status = D.orderStatus;

        const nav = `
<div class="oh-actgroup">
    <span class="oh-actgroup__label">바로가기</span>
    <button type="button" class="oh-btn oh-btn--primary" onclick="switchBal()">발주</button>
    <button type="button" class="oh-btn oh-btn--warn" onclick="switchDiary()" title="미리보기에서 고른 사람(발주자/수주자)의 일지">일지</button>
    <button type="button" class="oh-btn oh-btn--info" onclick="$j.p.showSettle()">정산</button>
    <button type="button" class="oh-btn oh-btn--ghost" onclick="openConfirmation()">작업확인서</button>
    <span class="oh-actgroup__spacer"></span>
    ${this.jinhaengBlock()}
    ${this.whoTabsBox()}
    ${this.foldBtn()}
</div>`;

        if (!D.ordernum) return `${nav}${this.matchBar()}`;

        const d1 = status == 6 ? '' : 'disabled';
        const d2 = status == 7 ? '' : 'disabled';
        const d3 = status == 8 ? '' : 'disabled';
        const dCancel = status == 99 ? 'disabled' : '';
        // 페널티취소·적용·재알림·회차·외부배차전환은 서버 판정(OrderPolicyService::adminActBlocks)만 본다.
        // 빈 문자열이면 할 수 있고, 아니면 그게 막힌 사유다. 여기서 상태값으로 조건을 새로 만들지 않는다.
        const B = D.actBlocks || {};
        const can = (k) => B[k] === '';

        const flow = `
<div class="oh-actgroup">
    <span class="oh-actgroup__label">요청</span>
    <button type="button" class="oh-btn oh-btn--success" ${d1} onclick="send_field_arrival_request(${o.num},${o.order_member_num || 0},${o.worker_num || 0},${OrderHandle.jsArg(o.site_address)})">현장도착요청</button>
    <button type="button" class="oh-btn oh-btn--success" ${d2} onclick="send_job_done_request(${o.num},${o.order_member_num || 0},${o.worker_num || 0},${OrderHandle.jsArg(o.site_address)})">작업완료요청</button>
    <button type="button" class="oh-btn oh-btn--success" ${d3} onclick="reqest_paymentdone(${o.num},${o.order_member_num || 0},${o.worker_num || 0},${OrderHandle.jsArg(o.site_address)})">수금완료요청</button>
    <span class="oh-actgroup__spacer"></span>
    ${this.jobChangerHtml()}
</div>`;

        // 도움말은 hover 전용(data-tip-hover)이다 — 눌리면 실제로 뭔가 일어나는 버튼들이라
        // 클릭까지 툴팁을 토글하면 방금 연 모달 위에 설명이 남는다 (Ui/Tooltip.js 의 규약).
        const tip = OrderHandle.tipAttr;

        const penaltyCancel = can('penaltyCancel')
            ? `<button type="button" class="oh-btn oh-btn--danger" onclick="cancel_penalty(${o.num})"`
              + tip('페널티취소', '수주자 잘못으로 오더를 취소한다. 오더가 취소(99)되고 수주자 포인트 -200, 수수료는 수주자 10% 부담으로 다시 계산된다. 발주개수·수주개수·-6차도 되돌아간다.')
              + `>페널티취소</button>` : '';
        const penaltyApply = can('penaltyApply')
            ? `<button type="button" class="oh-btn oh-btn--warn" onclick="apply_penalty(${o.num})"`
              + tip('페널티적용', '이미 취소된 오더에 수주자 페널티만 뒤늦게 매긴다. 포인트 -200 과 수수료 재계산은 페널티취소와 같고, 오더 상태는 그대로 취소로 남는다.')
              + `>페널티적용</button>` : '';
        const penaltyRevoke = can('penaltyRevoke')
            ? `<button type="button" class="oh-btn oh-btn--warn" onclick="revoke_penalty(${o.num})"`
              + tip('페널티해제', '페널티가 걸린 취소 오더에서 페널티분만 걷는다. 수주자 포인트 -200 이 돌아가고 수수료가 일반 취소(0원)로 다시 계산된다. 오더는 취소로 남고 발주개수·-6차 같은 취소분은 그대로다. 오더 자체를 살리려면 [취소원복].')
              + `>페널티해제</button>` : '';
        // 취소원복 — 취소 순간의 스냅샷이 있고 계획이 설 때만 뜬다 (OrderRestoreService::snapshotBlockReason).
        // 드물게 쓰는 구제용이라 눈에 안 띄게 둔다 — 무채색(ghost)으로 관리줄 맨 끝.
        const restoreBtn = can('restore')
            ? `<button type="button" class="oh-btn oh-btn--ghost" onclick="restore_cancel()"`
              + tip('취소원복', '실수로 취소한 오더를 취소 직전 상태로 되돌린다. 취소 때 남긴 스냅샷으로 포인트·발주개수·-6차·수수료를 함께 되돌리고, 끝에 원장을 취소 전과 대조해 다르면 아무것도 바꾸지 않는다. 이미 나간 취소 알림은 되돌리지 않는다.')
              + `>취소원복</button>` : '';
        const whanRollback = Number(o.whan_status) === 2
            ? `<button type="button" class="oh-btn oh-btn--warn" onclick="rollbackWhanwon(${o.num})"`
              + tip('환원원복', '환원을 없던 일로 되돌린다. 환원페널티(발주금지·수주금지)와 포인트 -10,000 이 사라지고 수수료는 다시 홀드된다. 오더는 작업완료(미수금)로 남는다 — 수금완료로 돌아가지 않는다.')
              + `>환원원복</button>` : '';

        // 환원보류: 대상 판정은 서버 하나(OrderPolicyService::isWhanEligible, D.whanEligible)만 본다.
        // 여기서 조건을 따로 들고 있지 않는다 — 배치·서버검증·화면이 서로 다른 기준을 갖게 되는 걸 막기 위함.
        const whanDeferable = Boolean(D.whanEligible) && Number(o.whan_status) !== 2;
        const whanDefer = !whanDeferable ? '' : (Number(o.whan_status) === 1
            ? `<button type="button" class="oh-btn oh-btn--warn" onclick="releaseWhanDefer(${o.num})"`
              + tip('환원보류해제', '보류를 풀어 다음 환원배치(매월 1일)부터 다시 환원 대상에 넣는다.')
              + `>환원보류해제</button>`
            : `<button type="button" class="oh-btn oh-btn--warn" onclick="make_whanDeferBox()"`
              + tip('환원보류', '이번 환원배치(매월 1일)에서 이 오더를 뺀다. 변제 협의중처럼 조금 더 기다려줄 때 쓴다. 사유 필수 — 작업내용 로그에 남는다.')
              + `>환원보류</button>`);

        // 환원처리: 수금완료(9) 를 되돌려 환원시킨다 — 발주자가 준다고 해놓고 안 준 건.
        // 월배치는 order_status<9 만 훑어서 이 건을 영영 못 잡는다. 대상 판정은 서버 하나
        // (OrderPolicyService::whanRevertBlockReason, D.whanRevertable)만 본다.
        const whanRevert = Boolean(D.whanRevertable)
            ? `<button type="button" class="oh-btn oh-btn--danger" onclick="make_whanRevertBox()"`
              + tip('환원처리', '준다고 해서 수금완료를 눌렀는데 실제로는 안 준 건. 수금완료를 취소하고 환원으로 확정한다. 발주자에게 환원페널티(발주금지·수주금지)와 포인트 -10,000. 월배치는 수금완료 오더를 못 잡으므로 이 버튼이 유일한 길이다.')
              + `>환원처리</button>` : '';

        const manage = `
<div class="oh-actgroup">
    <span class="oh-actgroup__label">관리</span>
    <button type="button" class="oh-btn oh-btn--ghost" ${can('rePush') ? '' : 'disabled'} onclick="re_sendOrder()"${tip('오더재알림', '매칭알림을 그대로 한 번 더 보낸다 — 매칭된 전원이 한꺼번에 받고, 알림함의 매칭오더가 맨 위로 올라온다. 상태·차수는 그대로다. 홀드 중이면 못 한다.')}>오더재알림</button>
    <button type="button" class="oh-btn oh-btn--ghost" onclick="more_order_show()"${tip('추가배차', '발주자 화면으로 대리진입해 이 오더와 같은 조건으로 한 건 더 발주한다. 장비가 여러 대 필요할 때 쓴다.')}>추가배차</button>
    <button type="button" class="oh-btn oh-btn--info" onclick="price_form(${o.num})" ${dCancel}${tip('금액변경', '장비대금을 고친다. 수수료도 새 금액으로 다시 계산되므로 양쪽 캐시가 모자라면 변경이 막힌다.')}>금액변경</button>
    <button type="button" class="oh-btn oh-btn--info" onclick="fee_form(${o.num})" ${dCancel}${tip('수수료변경', '이 오더의 수수료 있음/없음을 뒤집는다. 없음으로 바꾸면 홀드가 풀리고, 있음으로 바꾸면 다시 걷는다 — 캐시가 모자라면 막힌다.')}>수수료변경</button>
    <button type="button" class="oh-btn oh-btn--ghost" ${can('outBae') ? '' : 'disabled'} onclick="open_outBaecha()"${tip('외부배차전환', '회원이 아닌 기사에게 배차한다(임의발주). 이름·전화번호를 직접 넣는다. 앱 수주자가 붙은 적 없는 오더만 된다 — 수주대기까지의 오더와 수주 없이 취소된 오더.')}>외부배차전환</button>
    ${can('outBaeEdit') ? `<button type="button" class="oh-btn oh-btn--ghost" onclick="open_outWorkerEdit()"${tip('외부배차정보변경', '외부배차된 오더의 수주자 이름·전화번호만 고친다. 상태·배차시각은 그대로다. 보험 소속이면 머큐리에 오더를 다시 보낸다.')}>외부배차정보변경</button>` : ''}
    ${this.mercuryBtn()}
    <button type="button" class="oh-btn oh-btn--danger" ${dCancel} onclick="cancel_predo()"${tip('오더취소', '오더를 취소(99)한다. 사유 필수. 정산된 수수료·포인트가 되돌아가고 발주자에게 알림이 나간다(체크로 뺄 수 있다). 수주자 잘못이면 대신 [페널티취소]를 쓴다.')}>오더취소</button>
    ${penaltyCancel}${penaltyApply}${penaltyRevoke}${whanRollback}
    ${can('returnJob') ? `<button type="button" class="oh-btn oh-btn--danger" onclick="makeorderReturn(${o.num},${D.returnPee},${parseInt(o.car_price, 10) || 0},${D.returnPeeBonsa})"${tip('회차(작업종료)', '장비가 현장에 갔다가 일을 못 하고 돌아온 건. 장비대금을 회차비용으로 갈아끼우고 회차 오더로 표시한다. 회차는 수수료를 걷지 않고 환원 대상에서도 빠진다.')}>회차(작업종료)</button>` : ''}
    ${whanDefer}${whanRevert}${restoreBtn}
</div>`;

        return `${nav}${flow}${manage}${this.matchBar()}`;
    }

    /** 매칭 발송 현황 — 스티키 하단 2줄 (실제 발송 인원 비율 바 + 발송/미발송/비율) */
    matchBar() {
        const m = this.D.matchHis || { totalPush: 0, doneCnt: 0, worker: null };
        const w = m.worker;
        const total = m.totalPush || 0;

        // 어플발주(order_type=0)만 매칭발송이 의미 있음. 임의/예약/외부/지정(91~95)은 숨김.
        // 또한 매칭데이터가 없으면(g5_order_matchings 5일 경과 삭제 등) 표시 불필요.
        if ([91, 92, 93, 94, 95].includes(Number(this.o.order_type))) return '';
        if (!w && total <= 0) return '';
        const sent = w ? w.stopCnt : 0;                 // 실제 발송된 인원
        const rest = Math.max(0, total - sent);         // 미발송
        const pct = (w && total > 0) ? Math.round((sent / total) * 100) : 0;

        const legend = w
            ? `<span class="lg-sent"><i class="is-sent"></i>발송 ${sent}명</span>`
              + `<span class="lg-rest"><i class="is-rest"></i>미발송 ${rest}명</span>`
              + `<span class="lg-stage">총 ${w.totalRows}단계 중 ${w.sentStages}단계 진행</span>`
              + `<span class="oh-cov__pct">${pct}%</span>`
            : `<span>전체 매칭 ${total}명</span>`;

        const matchType = this.D.matchTypeStr
            ? `<span class="oh-matchbar__type">${this.D.matchTypeStr}</span>` : '';

        return `<div class="oh-matchbar">`
            + `<div class="oh-matchbar__row">`
            + `<span class="oh-actgroup__label">매칭발송</span>`
            + matchType
            + `<div class="oh-cov__track"><div class="oh-cov__fill" style="width:${pct}%"></div></div>`
            + `<button type="button" class="oh-btn oh-btn--ghost" style="padding:5px 12px" onclick="evtNoticeShow(${this.o.num})">알림내역</button>`
            + `</div>`
            + `<div class="oh-cov__legend">${legend}</div>`
            + `</div>`;
    }

    /** 환원보류 사유입력 모달 — 사유는 필수, 작업내용 로그의 "내용" 칸에 남는다. */
    whanDeferBox() {
        const { o } = this;
        return `
<div id="whanDeferBox" class="oh-modal" style="display:none">
    <div class="oh-modal__title">환원보류</div>
    <div class="oh-modal__body">
        <div class="oh-field">
            <label>사유</label>
            <input id="whanDefer_memo" type="text" maxlength="80" oninput="updateWhanDeferMemoCount()" placeholder="예) 변제 협의중, 10일까지 유예">
            <div class="oh-editable__count" id="whanDefer_memo_count">0/80</div>
        </div>
        <div class="oh-modal__foot">
            <button type="button" class="oh-btn oh-btn--primary" onclick="save_whanDefer()">확인</button>
            <button type="button" class="oh-btn oh-btn--ghost" onclick="make_whanDeferBox(-1)">취소</button>
        </div>
    </div>
    <input id="whanDefer_ordernum" type="hidden" value="${o.num}">
</div>`;
    }

    /**
     * 환원처리(수금완료 → 환원) 사유입력 모달.
     * 수금완료를 취소하고 곧바로 환원까지 밀어넣는 되돌릴 수 없는 조치라, 무슨 일이 일어나는지
     * 모달에 그대로 적는다. 사유는 필수이고 작업내용 로그의 "내용" 칸에 남는다.
     */
    whanRevertBox() {
        const { o } = this;
        return `
<div id="whanRevertBox" class="oh-modal" style="display:none">
    <div class="oh-modal__title">환원처리 (수금완료 → 환원)</div>
    <div class="oh-modal__body">
        <div class="oh-modal__desc">
            수금완료를 취소하고 이 오더를 <b>환원</b>으로 확정합니다.<br>
            발주자에게 <b>환원페널티(발주금지·수주금지)</b>와 <b>포인트 -10,000</b>이 부과되고,
            이미 정산된 <b>수수료는 되돌아갑니다</b> (수주자 환급 · 발주자 회수).
        </div>
        <div class="oh-field">
            <label>사유</label>
            <input id="whanRevert_memo" type="text" maxlength="80" oninput="updateWhanRevertMemoCount()" placeholder="예) 발주자 미지급 확인, 수주자 신고">
            <div class="oh-editable__count" id="whanRevert_memo_count">0/80</div>
        </div>
        <div class="oh-modal__foot">
            <button type="button" class="oh-btn oh-btn--danger" onclick="save_whanRevert()">환원처리</button>
            <button type="button" class="oh-btn oh-btn--ghost" onclick="make_whanRevertBox(-1)">취소</button>
        </div>
    </div>
    <input id="whanRevert_ordernum" type="hidden" value="${o.num}">
</div>`;
    }

    /** 수정/배차 옵션 선택 모달 */
    popMessageBox() {
        return `
<div id="Popmessageshow" class="oh-modal" style="display:none;width:360px">
    <div class="oh-modal__title">오더 수정배차 옵션선택</div>
    <div class="oh-modal__body">
        <div class="oh-radio-row">
            <label><input type="radio" name="ordertypesets" id="ordertypesets1" value="editnow"> 수정먼저하기</label>
            <label><input type="radio" name="ordertypesets" id="ordertypesets2" value="runitnow"> 지금 배차하기</label>
        </div>
        <div class="oh-modal__foot">
            <button type="button" class="oh-btn oh-btn--primary" onclick="editrunitCheck()">확인</button>
            <button type="button" class="oh-btn oh-btn--ghost" onclick="document.getElementById('Popmessageshow').style.display='none'">취소</button>
        </div>
    </div>
</div>`;
    }

    /**
     * 작업완료/수금완료 확인 폼 — checkJobChangers() 가 $j.Ui.JBModal 본문으로 렌더.
     * 작업메모·결제상태(미수/싸인/수금) 칸은 없다 — 메모는 저장되지 않았고 결제상태는 무엇을 골라도 처리가 같았다.
     * @param {number} n  8=작업완료, 9=수금완료 (라벨/문구를 상태에 맞게 구분)
     */
    workDoneBox(n) {
        const isPay = (n == 9);
        const doneBtn = isPay ? '수금완료' : '작업완료';
        const lead    = `${doneBtn} 알림발송 (수발주자)`;
        return `
<div class="oh-workdone">
    <div id="confirmcontbody">
        <div id="inside_message_text" style="font-size:10pt">
            <b><span id="don_title">${lead}</span></b>
        </div>
    </div>
    <div class="oh-workdone__btns">
        <input type="button" value="취 소" class="oh-btn oh-btn--ghost" onclick="pc_work_done_infos_Btn_cancel()">
        <input type="button" value="${doneBtn}" class="oh-btn oh-btn--primary" onclick="jobDOneSet()" id="work_donebtn_okmessage">
    </div>
</div>`;
    }

    // (제거) workInfoEditBox / multiuseForm — 관리자 작업메모편집 흐름. 열리는 함수(work_memo_do)가 호출된 적 없고
    // 저장(jobMgreSet)은 존재한 적 없는 __called_from_app.php 로 submit 하던 dead 코드였다(orderEdit.js 참고).
}
